import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const scrollToElement = (id) => {
    const el = document.getElementById(id);
    if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
        return true;
    }
    return false;
};

const ScrollHandler = () => {
    const location = useLocation();

    useEffect(() => {
        const id = location.state?.scrollTo || location.hash?.slice(1);
        if (!id) return;

        // Попробовать сразу
        let success = scrollToElement(id);

        // Если не получилось — повторить через 100ms
        if (!success) {
            const retryTimeout = setTimeout(() => {
                scrollToElement(id);
            }, 100);

            return () => clearTimeout(retryTimeout);
        }
    }, [location]);

    return null;
};

export default ScrollHandler;